// WinModal.jsx - 3Workers Theme
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const WinModal = ({ points }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#020817]/80 backdrop-blur-xl p-5"
    >
      <motion.div
        initial={{ scale: 0.8, y: 40 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 220, damping: 18 }}
        className="relative w-full max-w-md overflow-hidden rounded-3xl border border-yellow-500/30 bg-gradient-to-b from-[#0b1628] to-[#07101d] shadow-[0_0_60px_rgba(234,179,8,.15)]"
      >
        {/* Glow */}
        <div className="absolute -top-24 left-1/2 h-56 w-56 -translate-x-1/2 rounded-full bg-yellow-500/20 blur-[90px]" />

        <div className="relative p-8 text-center">

          {/* Trophy */}
          <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full border border-yellow-500/30 bg-yellow-500/10 shadow-lg">
            <span className="text-5xl">🏆</span>
          </div>

          {/* Heading */}
          <h2 className="text-3xl font-extrabold text-white">
            Congratulations!
          </h2>

          <p className="mt-2 text-sm uppercase tracking-[4px] text-yellow-400">
            Task Completed Successfully
          </p>

          {/* Points */}
          <div className="my-8">
            <div className="text-6xl font-black text-yellow-400 drop-shadow-lg">
              {points}
            </div>

            <div className="mt-2 text-sm uppercase tracking-[3px] text-slate-400">
              Reward Points Earned
            </div>
          </div>

          {/* Status */}
          <div className="mb-8 rounded-2xl border border-blue-500/20 bg-blue-500/10 px-4 py-3">
            <p className="text-sm text-slate-300">
              {points >= 90
                ? "Outstanding Performance 🚀"
                : points >= 70
                ? "Excellent Work 🎉"
                : "Rewards Successfully Added"}
            </p>
          </div>

          {/* Button */}
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/")}
            className="w-full rounded-2xl bg-gradient-to-r from-yellow-500 to-amber-400 py-4 text-lg font-bold text-slate-900 shadow-lg transition-all hover:shadow-yellow-500/30"
          >
            Claim Reward
          </motion.button>

          <p className="mt-5 text-xs tracking-[3px] uppercase text-slate-500">
            3Workers Reward System
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default WinModal;